import { useEffect, useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import { onAuthStateChanged } from 'firebase/auth';
import { primaryAuth } from './firebase';
import Home from './view/home';
import SignIn from './view/signIn';
import './App.scss';

export default function App() {
  const [currentUser, setCurrentUser] = useState(undefined);

  useEffect(() => {
    // listen for changes in user authentication state
    onAuthStateChanged(primaryAuth, (user) => setCurrentUser(user?.uid));
  }, []);

  return (
    <div className="app">
      <ConfigProvider theme={{ token: { fontFamily: 'IBM Plex Sans' } }}>
        <Routes>
          <Route
            path="*" // user should stay in `/home` subdir
            element={
              currentUser !== null ? (
                <Navigate to="/home" />
              ) : (
                <Navigate to="/signIn" />
              )
            }
          />
          <Route
            path="/home/*"
            element={
              currentUser !== null ? <Home /> : <Navigate to="/signIn" />
            }
          />
          <Route path="/signIn" element={<SignIn />} />
        </Routes>
      </ConfigProvider>
    </div>
  );
}
